import React, { Fragment, useState, useEffect } from "react"
import ElementsButton from "./ElementsButton"
import { useDispatch, useSelector } from "react-redux"
import ListButton from "./ListButton"
import { setCurrentFilter, searchForTopicAPI, setCancelFilterRangerUpdated, setForceFilterRefresh } from "../../actions/buildconceptActions"
import { hideAlertAction } from "../../actions/alertActions"
import Tooltip from "@material-ui/core/Tooltip"
import InfoDialog from "../common/InfoDialog"
import { Typography } from "@material-ui/core"
import { Dropdown, DropdownButton } from "react-bootstrap"
import color_legend from "../../images/color_legend.png"
import color_legend_2 from "../../images/color_legend_2.png"
import Rainbow from "../Rainbow"
import { KNOWLEDGE_BASES } from "../../utils"

const FiltersBuild = ({
	createFilter,
	viewItemsBtn,
	setViewItemsBtn,
	setNeedToFilter,
	counterDocs,
	setCounterDocs,
	setCurrentSearchTermsSelected,
	refreshCloudList,
	showColorLegend,
}) => {
	/* ******************* REDUX STORE ******************* */
	//Redux
	const dispatch = useDispatch()
	const filterState = useSelector((state) => state.buildconcept.currentFilter)
	const [positiveRangeControl, setPositiveRangeControl] = useState("")
	const searchTopic = (item) => dispatch(searchForTopicAPI(item))
	const currentFilter = useSelector((state) => state.buildconcept.currentFilter)
	const targetTerms = useSelector((state) => state.buildconcept.targetTerms)
	const searchTerms = useSelector((state) => state.buildconcept.searchTerms)
	const ignoreTerms = useSelector((state) => state.buildconcept.ignoreTerms)
	const includeSpecificTerms = useSelector((state) => state.buildconcept.includeSpecificTerms)
	const ignoreSpecificTerms = useSelector((state) => state.buildconcept.ignoreSpecificTerms)
	const forceFilterRangeRefresh = useSelector((state) => state.buildconcept.force_filter_refresh)
	const conceptDocs = useSelector((state) => state.buildconcept.concept_docs)
	const isLoading = useSelector((state) => state.buildconcept.loading)
	const documnetLoading = useSelector((state) => state.buildconcept.loading_docs)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Component states
	const [filter, updateFilter] = useState({
		positiveRange: filterState.phrase_count,
		positiveNumber: filterState.phrase_count,
		negativeRange: filterState.neg_phrase_count,
		negativeNumber: filterState.neg_phrase_count,
	})
	// eslint-disable-next-line
	const [isUpdating, setIsUpdating] = useState(false)
	const [lastPositiveSearch, setLastPositiveSearch] = useState(filter.positiveRange)
	const [minPositiveRangeValue, setMinPositiveRangeValue] = useState(1)
	const [minNegativeRangeValue, setMinNegativeRangeValue] = useState(0)
	// Input focus Other Synonyms / Exclude terms
	const [focusSynonyms, setFocusSynonyms] = useState(false)
	const [focusExclude, setFocusExclude] = useState(false)
	/* ******************* END REACT STATES ******************* */

	/* ******************* VARIABLES ******************* */
	// Get inputs results
	const { positiveRange, positiveNumber, negativeRange, negativeNumber } = filter
	/* ******************* END VARIABLES ******************* */

	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		refreshList()
	}, [refreshCloudList])

	useEffect(() => {
		// console.log('focusSynonyms: ' + focusSynonyms);
		// console.log('focusExclude: ' + focusExclude);
	}, [focusSynonyms, focusExclude])

	//Setting min range of sliders
	useEffect(() => {
		let minPositive = targetTerms.length + includeSpecificTerms.length
		let minNegative = ignoreTerms.length + ignoreSpecificTerms.length
		setMinPositiveRangeValue(minPositive)
		setMinNegativeRangeValue(minNegative)

		if (positiveRange < minPositive) {
			updateFilter({
				...filter,
				positiveRange: minPositive,
				positiveNumber: minPositive,
			})
		}
		if (negativeRange < minNegative) {
			updateFilter({
				...filter,
				negativeRange: minNegative,
				negativeNumber: minNegative,
			})
		}
	}, [targetTerms, ignoreTerms, includeSpecificTerms, ignoreSpecificTerms])

	useEffect(() => {
		if (forceFilterRangeRefresh === true) {
			updateFilter({
				positiveRange: currentFilter.phrase_count,
				positiveNumber: currentFilter.phrase_count,
				negativeRange: currentFilter.neg_phrase_count,
				negativeNumber: currentFilter.neg_phrase_count,
			})
			// dispatch(setCancelFilterRangerUpdated());
			dispatch(setForceFilterRefresh())
		}
	}, [forceFilterRangeRefresh])

	useEffect(() => {
		//Create a delay to wait until range selector finish
		if (!isUpdating) {
			setIsUpdating(true)
			setTimeout(function () {
				if (lastPositiveSearch !== filter.positiveRange) {
					//refreshList();
					setLastPositiveSearch(filter.positiveRange)
				}
				setIsUpdating(false)
			}, 2000)
		}
	}, [filter.positiveRange])

	useEffect(() => {
		if (negativeNumber !== filterState.neg_phrase_count || positiveNumber !== filterState.phrase_count) {
			dispatch(setCurrentFilter({ ...filterState, neg_phrase_count: filter.negativeNumber, phrase_count: filter.positiveRange }))
			//If negative range changes, we need to search for new documens with negatives
		}
		return
	}, [filter])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	const refreshList = () => {
		dispatch(hideAlertAction())
		const searchItem = {
			knowledgebase: KNOWLEDGE_BASES.COMBINED,
			target_terms: targetTerms,
			ignore_terms: ignoreTerms,
			soft_ignore: ignoreSpecificTerms,
			soft_target: includeSpecificTerms,
			phrase_count: filter.positiveRange,
			neg_phrase_count: filter.negativeRange,
			//search_terms: searchTerms,
			strict: true,
		}
		setCurrentSearchTermsSelected({
			target_terms: targetTerms,
			ignore_terms: ignoreTerms,
			soft_ignore: ignoreSpecificTerms,
			soft_target: includeSpecificTerms,
			//search_terms: searchTerms,
		})
		//MODIFIY searchItem IN THE FUTURE TO SEARCH FULL SAVED CONCEPT
		//searchItem.target_terms.push(inputSearch);
		searchTopic(searchItem)
	}

	// Input function
	const updatePositiveRangeBlur = () => {
		if (positiveNumber < minPositiveRangeValue) {
			updateFilter({
				...filter,
				positiveRange: minPositiveRangeValue,
				positiveNumber: minPositiveRangeValue,
			})
		}
	}

	const updatePositiveRange = (e) => {
		// console.log(focusSynonyms);
		if (focusSynonyms === true) {
			// console.log('onFocus');
			updateFilter({
				...filter,
				positiveRange: e.target.value,
				positiveNumber: e.target.value,
			})
			return
		}
		if (e.target.value >= minPositiveRangeValue) {
			updateFilter({
				...filter,
				positiveRange: e.target.value,
				positiveNumber: e.target.value,
			})
		} else {
			updateFilter({
				...filter,
				positiveRange: minPositiveRangeValue,
				positiveNumber: minPositiveRangeValue,
			})
		}
		setCounterDocs("")
		//dispatch(setCurrentFilter({...filterState, "phrase_count": filter.positiveNumber }));
	}

	const updateNegativeRangeBlur = () => {
		if (negativeNumber < minNegativeRangeValue) {
			updateFilter({
				...filter,
				negativeRange: minNegativeRangeValue,
				negativeNumber: minNegativeRangeValue,
			})
		}
	}

	const updateNegativeRange = (e) => {
		if (focusExclude === true) {
			// console.log('onFocus');
			updateFilter({
				...filter,
				negativeRange: e.target.value,
				negativeNumber: e.target.value,
			})
			return
		}

		if (e.target.value >= minNegativeRangeValue) {
			updateFilter({
				...filter,
				negativeRange: e.target.value,
				negativeNumber: e.target.value,
			})
		} else {
			updateFilter({
				...filter,
				negativeRange: minNegativeRangeValue,
				negativeNumber: minNegativeRangeValue,
			})
		}

		setCounterDocs("")

		//If range is changed to fast, there is no time enought to update it. We set a timer to wait for secundary changes.
		/*if (currentFilter.isLoading){

        }else{
            dispatch(setCurrentFilter({...filterState, "neg_phrase_count": filter.negativeNumber }));
        }*/
	}

	// Form submitted
	const submitFilterForm = (e) => {
		e.preventDefault()

		// Form validation or other function.

		// Create Filter
		createFilter(filter)
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	return (
		<Fragment>
			<div className="container-fluid mb-2">
				<div className="col-12 divFilters d-flex justify-content-between">
					<form onSubmit={submitFilterForm}>
						<div className="divBlockFilterBuild divOtherSynonyms font-12" id="other_syn">
							<label htmlFor="positiveConnotations" className="form-label">
								Other synonyms amount:{" "}
							</label>
							<input
								type="range"
								name="positiveRange"
								className="form-range rangeBar"
								min={minPositiveRangeValue}
								max="200"
								step="1"
								id="positiveConnotations"
								onChange={updatePositiveRange}
								value={positiveRange}
								onClick={(e) => {
									setPositiveRangeControl("slider")
								}}
							/>
							<input
								data-cy="input_other_synonyms"
								type="number"
								name="positiveNumber"
								id="number"
								className="rounded inputFilterPositive"
								min={minPositiveRangeValue}
								max="200"
								onFocus={(e) => {
									setFocusSynonyms(true)
								}}
								onBlur={(e) => {
									setFocusSynonyms(false)
									updatePositiveRangeBlur()
								}}
								//onkeyup="changeRangeValue(this.value)"
								onChange={updatePositiveRange}
								value={
									positiveNumber <= 200
										? positiveNumber
										: updateFilter({
												...filter,
												positiveNumber: 200,
										  })
								}
								onKeyPress={(e) => {
									e.key === "Enter" && e.preventDefault()
								}}
							/>
							<br />
						</div>

						<div className="col-2 divBlock pl-2 d-flex align-items-center" id="btnRefreshList">
							<button
								data-cy="refresh_button"
								type="submit"
								className="btn btn-primary btn-sm heigth-30 btnRefreshTermsList mt6 mr-1"
								onClick={refreshList}
							>
								REFRESH TERMS LIST
							</button>
							<div style={{ marginLeft: 10 }}>
								<InfoDialog btninfo="filtersBuild" />
							</div>
						</div>
					</form>

					<div>
						<ListButton viewItemsBtn={viewItemsBtn} setViewItemsBtn={setViewItemsBtn} setNeedToFilter={setNeedToFilter} />
						<Tooltip
							title={
								<Fragment>
									<Typography color="inherit">WordCloud</Typography>
									{"View the terms as wordcloud"}
								</Fragment>
							}
							placement="bottom"
							arrow
						>
							<button
								data-cy="wordcloud_button"
								onClick={(e) => {
									e.preventDefault()
									setViewItemsBtn("cloud")
									setNeedToFilter(true)
								}}
								className={
									viewItemsBtn === "cloud"
										? "btn btn-primary  btnViewsFilterBuild ml-2 btn-small-filter"
										: "btn btn-outline-primary  btnViewsFilterBuild ml-2 btn-small-filter"
								}
							>
								<i className="bi bi-cloud-haze"></i>
							</button>
						</Tooltip>
						<ElementsButton
							viewItemsBtn={viewItemsBtn}
							setViewItemsBtn={setViewItemsBtn}
							setNeedToFilter={setNeedToFilter}
							counterDocs={counterDocs}
							setCounterDocs={setCounterDocs}
							isLoading={isLoading || documnetLoading}
						/>
					</div>
				</div>
			</div>
		</Fragment>
	)
}

export default FiltersBuild
